<template>
    <b-form-group :label="label"
                  :invalid-feedback="errorTxt"
                  :state="state">
      <b-form-select :style="fullWidth ? 'max-width: 100%' : 'max-width: 466px;'"
                v-model="inputVal"
                :options="options"
                :state="state"
                :readonly="readonly"
                @change="$emit('change')">
        </b-form-select>
    </b-form-group>
</template>

<script>
    export default {
        props: ['model', 'attribute', 'label', 'options', 'errors', 'readonly', 'errorOnly', 'fullWidth'],
        data() {
            return {inputVal: this.model[this.attribute] ? this.model[this.attribute] : null, state: null, errorTxt: ''}
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute];
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
    }
</script>